module.exports = __webpack_public_path__ + "static/media/hands_28.f361634f.svg";